import React, {useState} from "react";
import {useQueryClient} from "react-query";
import { makeStyles } from "@material-ui/core/styles";
import { InputLabel, Chip, Popover, Grid, Typography, MenuItem, Menu, Fade } from "@material-ui/core";
import { AddOutlined, ArrowDropDown } from "@material-ui/icons";
import __ from "lodash";
import { Alert, Form, MaskedNumber, UldContourSelect } from ".";
import { useComboValues } from "../services/settings";

const UldAllocationSelect = (props) => {

  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300,
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    chipWithNoLabel: {
      margin: 2,
      '& .MuiChip-labelSmall': {
        paddingRight: 0,
      }
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
    menuPaper: {
      maxHeight: 500
    }
  }));

  const {id, label, readOnly, disabled, onChange, value: values} = props;
  const [oldValues, setOldValues] = useState(values);
  const [valuesArray, setValuesArray] = useState(values || []);
  const [addContourEl, setAddContourEl] = React.useState(null);
  const [selectContourEl, setSelectContourEl] = React.useState(null);
  const showSelector = Boolean(addContourEl);
  const showContourSelector = Boolean(selectContourEl);
  const queryClient = useQueryClient();

  const comboValues = useComboValues({queryClient, extraKeys:['ULD ALLOCATION'], useCache: true});

  if (values !== oldValues) {
    setValuesArray(values);
    setOldValues(values);
  }
  const classNames = [props.className];
  if (props.readOnly) {
    classNames.push('readOnly');
  }

  const className = classNames.join(" ");
  const classes = useStyles();

  const handleAdd = (event) => {
    setAddContourEl(event.currentTarget);
  };

  const handleSelect = (event) => {
    setSelectContourEl(event.currentTarget);
  };

  const handleDelete = ({value, position}) => {
    const values = [...valuesArray];
    values.splice(position,1);
    setValuesArray(values);
    if (onChange) {
      onChange({uldAllocation: values});
    }
  }

  const handleSelectContour = (record) => {
    const contour = __.pick(record,
      ['contourCode', 'quantity']);
    const values = [...valuesArray, contour];
    setAddContourEl(null);
    setValuesArray(values);
    if (onChange) {
      onChange({uldAllocation: values});
    }
  }

  const handleLoadContours = (data) => {
    if (data) {
      setValuesArray(data.uldAllocation);
      onChange(data);
    }
  }

  const handleCloseSelector = () => {
    setAddContourEl(null);
  };

  const handleCloseContourSelector = () => {
    setSelectContourEl(null);
  };

  const Validator = (props) => {
    const record = props.record;
  
    const [state, setState] = useState({
      error: null,
      errorMessage: null
    }); 
  
    let error = false;
    let errorMessage = "";
  
    if (!error && !record.contourCode) {
      error = true;
      errorMessage = "'Contour Code' is required";
    }
    if (!error && (!record.quantity || isNaN(record.quantity || record.quantity < 1 || record.quantity > 99))) {
      error = true;
      errorMessage = "A valid 'Quantity' is required";
    }
  
    if (error !== state.error || errorMessage !== state.errorMessage) {
      setState({ ...state, error, errorMessage });
      if (props.onChange) {        
        props.onChange({ error, errorMessage });
      }
    }
  
    return (
      <Alert open={error} severity="error" message={errorMessage}/>
    );
  }

  return (
    <div className={className}>
      {label?
        <InputLabel shrink id={`${id}-label`} style={{position: "relative", marginBottom: 0}} >{label}</InputLabel>
        :<></>
      }
      <div className={classes.chips} style={{...props.chipsStyle}}>
        {valuesArray.map((record, i) => (
          <Chip
            key={i}
            label={`${record.quantity} x ${record.contourCode}`}
            className={classes.chip}
            style={{...props.chipStyle}}
            size={"small"}
            onDelete={readOnly||disabled?null:()=>handleDelete({record, position: i})}
          />
        ))}
        {props.comboForm || readOnly||disabled||(Array.isArray(valuesArray) && valuesArray.length > 0)?<></>:
        <Chip
          key={'select'}
          color="primary"
          icon={<ArrowDropDown/>}
          className={classes.chipWithNoLabel}
          style={{...props.chipStyle}}
          size={"small"}
          onClick={(e)=>handleSelect(e)}
        />}
        {props.comboForm || readOnly||disabled||(Array.isArray(valuesArray) && valuesArray.length > 0)?<></>:
        <Menu
          id="fade-menu"
          MenuListProps={{
            'aria-labelledby': 'fade-button',
          }}
          anchorEl={selectContourEl}
          open={showContourSelector}
          onClose={handleCloseContourSelector}
          TransitionComponent={Fade}
        >
          {!readOnly && !disabled && (comboValues && Array.isArray(comboValues.data)) ?
            comboValues.data.map((option) => {
              return (
                <MenuItem onClick={() => handleLoadContours(option.data)} key={option.code} value={option.code}>{option.value}</MenuItem>
              )
            })
            :null
          }
        </Menu>}
        {readOnly||disabled?<></>:
        <Chip
          key={'add'}
          color="primary"
          icon={<AddOutlined/>}
          className={classes.chipWithNoLabel}
          style={{...props.chipStyle}}
          size={"small"}
          onClick={(e)=>handleAdd(e)}
        />}
        {readOnly||disabled?<></>:
          <Popover
            id={id}
            open={showSelector}
            anchorEl={addContourEl}
            onClose={handleCloseSelector}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Form key="form"
              open={true}
              record={{contourCode: null, quantity: 0}}
              validator={Validator}
              validatorPosition="bottom"
              validatorStyle={{padding: 0}}
              formBodyStyle={{maxHeight: "calc(100vh - 320px)"}}
              buttonBarStyleOverride={{position: "relative", width: "calc(100% - 30px)", marginTop: -30}}
              buttons = {
                {
                  save:{icon: "check_circle", key: "Add", label: "Add", color: "primary", disabled: (status)=>{return status.error}}, 
                  cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
                }
              }
            
              onChange={(state) => {
                if (state.buttonPressed === "cancel") {
                  handleCloseSelector()
                }
                if (state.buttonPressed === "save") {
                  const record = state.record;
                  handleSelectContour(record);
                }
              }}
            >
              <div style={{paddingBottom: 10}}>
                <div style={{padding: "10px 0px"}}>
                  <Typography sx={{ p: 2 }}>Please select a contour and quantity</Typography>
                </div>
                <Grid container checkChildren={true} spacing={3}>
                  <Grid item xs={6} checkChildren={true}>
                    <UldContourSelect 
                      id="contourCode"
                      label="Contour"
                      uldType=""
                    />
                  </Grid>    
                  <Grid item xs={6} checkChildren={true}>
                    <MaskedNumber 
                      id="quantity"
                      label="Quantity"
                      inputLabelProps={{shrink: true}}
                      decimalScale={0}
                      fixedDecimalScale={true}
                    />
                  </Grid>    
                </Grid>
              </div>
            </Form>
          </Popover>
        }
      </div>
    </div>
  );
}

export default UldAllocationSelect;
